import { render } from "./NewAccount.vue?vue&type=template&id=2c56c73b"
import script from "./NewAccount.vue?vue&type=script&lang=js"
export * from "./NewAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__